import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MuiRightAppBarContent } from './mui-hero-right-app-bar.component';

@Injectable({
  providedIn: 'root'
})
export class MuiHeroRightAppBarService {
  readonly rightAppBarContent$: Observable<MuiRightAppBarContent | null>;

  private _rightAppBarContent: BehaviorSubject<MuiRightAppBarContent | null>;

  set rightAppBar(newContent: MuiRightAppBarContent) {
    this._rightAppBarContent.next(newContent);
  }

  constructor() {
    this._rightAppBarContent = new BehaviorSubject<MuiRightAppBarContent | null>(null);
    this.rightAppBarContent$ = this._rightAppBarContent.asObservable();
  }
}
